import SignUpForm from './SignUpForm'

export default SignUpForm



// WEBPACK FOOTER //
// ./src/components/SignUpForm/index.js